import clsx from 'clsx';
import { useParams } from 'next/navigation';
import Link from 'next/link';
import { useUserContext } from '@/app/context/UserContext';
import { useMemo, useRef } from 'react';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { ICompany, ICompanyConfig } from '@/app/types/types';
export const CareerHeader = ({
  className
}) => {
  const {
    companySlug
  } = useParams();
  const {
    isUserLoading
  } = useUserContext();
  const {
    data: companyData
  } = useQuery({
    queryKey: ['company', 'career-page', companySlug],
    queryFn: async () => {
      const res = await axios.get('/api/company', {
        params: {
          requestType: 'companySlug',
          companySlug
        }
      });
      return res.data?.data;
    },
    enabled: Boolean(companySlug) && !isUserLoading,
    throwOnError: false
  });
  const companyLogoUrl = useMemo(() => {
    if (companyData?.companyConfig?.showCompanyLogo) {
      if (companyData?.companyConfig?.companyLogoUrl) {
        return companyData?.companyConfig?.companyLogoUrl;
      }
      return `/images/logo/${companySlug}.png`;
    }
    return '';
  }, [companyData, companySlug]);
  return <div className={clsx(className, ' border-b mb-10')}>
            <div className="w-full max-w-6xl mx-auto py-4 px-2">
                <Link href={`/${companySlug}/career/jobs`} prefetch={false} className="flex items-center w-full justify-between">
                    <div className="flex items-center gap-2">
                        {/* eslint-disable-next-line @next/next/no-img-element */}
                        <img src={companyLogoUrl || undefined} alt={companySlug || 'Company Logo'} className="cursor-pointer h-8 w-auto" />
                        <span className="text-xl font-bold">|</span>
                        <span className="text-xl font-medium">Careers</span>
                    </div>
                </Link>
            </div>
        </div>;
};